import React from "react"
import types from "prop-types"
import clsx from "clsx"

const MassSelection = ({ deselectAll, selectAll, className = "" }) => {
  const select = (event) => {
    event.preventDefault()
    selectAll()
  }

  const deselect = (event) => {
    event.preventDefault()
    deselectAll()
  }

  return (
    <div className={clsx("flex gap-4 text-xs text-dark", className)}>
      <button onClick={select}>select all</button>
      <button onClick={deselect}>deselect all</button>
    </div>
  )
}

MassSelection.propTypes = {
  deselectAll: types.func.isRequired,
  selectAll: types.func.isRequired,
  className: types.string,
}

export default MassSelection
